import React, { useState, useEffect } from 'react';

import MoreInfo from "../components/MoreInfo";
import '../styles/views/formuleSurMesure.css'
import PositifPoint from "../components/PositifPoint";
import Conditionnement from "../components/Conditionnement"
import CategoryCard from "../components/CategoryCard";
import Process from '../components/Process';
import Popup from '../components/Popup';

import img_fiole from '../assets/img/formule_intro_fiole.png';
import img_packaging from '../assets/img/formule_packaging.png'

import icon_gelule from '../assets/icons/gelules.png';
import icon_capsules from '../assets/icons/capsules.svg';
import icon_piluliers from '../assets/icons/piluliers.png'
import icon_blister from '../assets/icons/blister.svg';
import icon_flacons from '../assets/icons/flacons.svg';
import icon_doypacks from '../assets/icons/doypacks.png';

//icon carousel
import icon_arrow_forward from '../assets/icons/arrow_forward.svg';
import icon_arrow_back from '../assets/icons/arrow_back.svg';

//icon process
import cahier from "../assets/icons/cahier.png";
import dev from "../assets/icons/dev.png";
import prod from "../assets/icons/prod.png";
import packaging from "../assets/icons/packaging.png";
import conditionnement from "../assets/icons/conditionnement.png";
import envoi from "../assets/icons/envoi.png"

import img_sur_mesure_mobile from "../assets/icons/img-sur-mesure-mobile.png"

export default function FormuleSurMesure() {
    const [isCarousel, setIsCarousel] = useState(false);
    const [isMobile, setIsMobile] = useState(0);
    const [forceReloadKey, setForceReloadKey] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentIndexProcess, setCurrentIndexProcess] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const content = [
        ["A unique product", "Develop an original formula that reflects your vision and stands out in the market."],
        ["Adapting to specific needs", "Target specific issues such as stress, immunity, performance..."],
        ["Selection of ingredients", "Select innovative active ingredients or natural ingredients to meet your consumers' expectations."],
        ["Promote your brand", "You decide everything: dosage, dosage form (capsules, tablets, powder), flavours and much more."],
        ["Valorisation de votre marque", "Offer food supplements that embody your values and create a strong bond with your customers."]
    ]

    const process = [
        [
            cahier,
            "specifications",
            "We work closely with you to define your objectives, the specific needs of your customers, and the characteristics of the formula you desire. These specifications provide a solid and precise basis for each stage of development."
        ],
        [
            dev,
            "development",
            "Our R&D team takes charge of formulation, selecting innovative, high-performance ingredients  that meet expectations in terms of efficiency, stability and bioavailability."
        ],
        [
            prod,
            "PRODUCTION",
            "In our laboratory, we apply strict standards and advanced techniques to produce batches of various sizes. We ensure continuous quality control to guarantee a high-quality finished product."
        ],
        [
            packaging,
            "customized packaging",
            "To optimise the user experience and reflect your brand identity, we offer a wide choice of customised packaging, from design to final format."
        ],
        [
            conditionnement,
            "packaging",
            "Each product is packaged according to your preferences : bottles, blister packs, pouches or other formats. Our packaging flexibility enables us to meet the specific requirements of your points of sale and distribution."
        ],
        [
            envoi,
            "product delivery",
            "Once the product has been finalised, we ensure that it is dispatched, whether for direct distribution to dispatch centres or delivery to sales outlets."
        ]
    ]

    const content_galeniques = [
        [icon_gelule, "CAPSULES", "Pullulan, HPMC...", true],
        [icon_capsules, "SOFTGELS", "Marine or plant origin..."],
        [icon_piluliers, "BOTTLES", "Plastic, glass or eco-friendly..."],
        [icon_blister, "BLISTER", "In PVC, PVDC </br> Aluminium sealing..."],
        [icon_flacons, "DROPPING BOTTLE", "Made of glass"],
        [icon_doypacks, "POUCHES", "Eco-responsible <br> (biodegradable, compostable)", true]
    ]

    const categories = [
        {
            title: "Liposomes",
            subtitle: "Plant extracts Vitamins · Minerals",
            type: "liposome",
            link: "/liposomes",
        },
        {
            title: "Niosomes",
            subtitle: "Cosmetics",
            type: "niosome",
            link: "/niosomes",
        },
        {
            title: "Probiotiques & postbiotiques",
            subtitle: "VPRO® and prolipo® technologies",
            type: "probiotique",
            link: "/probiotiques",
        },
    ];

    useEffect(() => {
        const handleResize = () => {
            setIsCarousel(window.innerWidth <= 1420);
            setIsMobile(window.innerWidth <= 1050);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % categories.length);
        setForceReloadKey((prevKey) => prevKey + 1);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            (prevIndex - 1 + categories.length) % categories.length
        );
        setForceReloadKey((prevKey) => prevKey + 1);
    };

    const handlePrevProcess = () => {
        setCurrentIndexProcess((prevIndex) =>
            prevIndex === 0 ? process.length - 1 : prevIndex - 1
        );
    };

    const handleNextProcess = () => {
        setCurrentIndexProcess((prevIndex) =>
            prevIndex === process.length - 1 ? 0 : prevIndex + 1
        );
    };

    const handleClick = () => {
        openPopup();
    };

    const openPopup = () => setIsPopupOpen(true);
    const closePopup = () => setIsPopupOpen(false);

    return (
        <div>
            <div className="formule_global-container">
                <section className="formule_intro-container-global">
                    {isMobile ? (
                        <div className='formule_intro-container'>
                            <h1 className="formule_intro-title">
                                <label className="bold formule_font-50">our custom made</label> <br />
                                <label className='orange-color'>package</label>
                            </h1>
                            <MoreInfo
                                label={"Request our catalogue"}
                                link={"download"}
                            />
                            <h2 className="formule_intro-subtitle">Create your <label className='orange-color'>tailor-made <br /> PRODUCTS with LIN</label></h2>
                            <article className="formule_intro-text">
                                Because your needs are unique, LIN creates tailor-made formulas, adapted to the specific requirements of each brand. Whether responding to market trends or the requirements of a particular niche, our scientific and marketing teams work together to develop unique products  that stand out and add value for consumers.
                            </article>
                        </div>
                    ) : (
                        <div className='formule_intro-container'>
                            <h1 className="formule_intro-title">
                                <label className="bold formule_font-50">our custom made</label> <br />
                                <label className='orange-color'>package</label>
                            </h1>
                            <MoreInfo
                                label={"Request our catalogue"}
                                link={"download"}
                            />
                            <h2 className="formule_intro-subtitle">Create your <label className='orange-color'>tailor-made <br /> PRODUCTS with LIN</label></h2>
                            <article className="formule_intro-text">
                                Because your needs are unique, LIN creates tailor-made formulas, adapted to the specific requirements of each brand. Whether responding to market trends or the requirements of a particular niche, our scientific and marketing teams work together to develop unique products  that stand out and add value for consumers.
                            </article>
                        </div>
                    )}
                    {!isMobile && <img className='formule_intro-container-img' src={img_sur_mesure_mobile} />}
                </section>
                <section className="formule_ourFormule-container">
                    <h3 className='formule_ourFormule-title'><br /> YOUR tailor-made <label className="orange-color"> brand</label></h3> 
                    <div className='formule_ourFormule-bloc-container'>
                        <div className='formule_ourFormule-text-container'>
                            <h3 className='formule_ourFormule-title-bloc'>YOUR <label className="orange-color">PERSONALISED<br /> FORMULA</label></h3>
                            <article>Create unique dietary supplements and cosmetics with our tailor-made formulas. We tailor each product to your specifications, selecting innovative ingredients and guaranteeing quality, compliance and efficacy.</article>
                            <img className='formule_ourFormule-img' src={img_fiole} />
                        </div>
                        <p className='formule_ourFormule-plus'>+</p>
                        <div className='formule_ourFormule-text-container'>
                            <h3 className='formule_ourFormule-title-bloc'><label className="orange-color">your packaging</label></h3>
                            <article>We adapt each product to your image  through fully customised packaging. Whether it's a box, bottle or pouch, we integrate your graphic elements to reflect your brand identity, while guaranteeing practicality, stability and optimum protection of the formulas.</article>
                            <img className='formule_ourFormule-img' src={img_packaging} />
                        </div>
                    </div>
                </section>
                <section className="fomrule_positifPoint-container">
                    <div className='fomrule_positifPoint-container2'>
                        <div className='formule_positifPoint-text-container'>
                            <h3 className='formule_positifPoint-title'><label className="orange-color">the benefits</label> of the <br />tailor-made formula</h3>
                            <article>A tailor-made formula consists of creating a food supplement or beauty product that is totally adapted to your expectations, from the selection of ingredients to the packaging. Unlike white labels, custom formulas give you total freedom to develop a unique product or meet specific needs that are perfectly suited to your target and your values.</article>
                        </div>
                        <div>
                            {content.map(([title, content], index) => (
                                <PositifPoint key={index} title={title} content={content} />
                            ))}
                        </div>
                    </div>
                </section>
                <div className="vertical-line"></div>
                <section className='formule_process_global-container'>
                    <h3 className='formule_process-title'>our product development <label className='orange-color'>process</label></h3>
                    <p className='formule_process-subtitle'>Our tailor-made creation method follows a rigorous six-step process, <br /> that guarantees a unique formulation and impeccable quality.</p>
                    <div className="formule_process_comp-container">
                        {isCarousel ? (
                            // Mode CAROUSEL (Mobile)
                            <div>
                                <div className="carousel_container">
                                    <Process
                                        img={process[currentIndexProcess][0]}
                                        title={process[currentIndexProcess][1]}
                                        content={process[currentIndexProcess][2]}
                                        index={currentIndexProcess + 1}
                                    />
                                </div>
                                <div className='formule_arrow_container--mobile'>
                                    <img className="carousel_arrow" alt="Flèche gauche" src={icon_arrow_back} onClick={handlePrevProcess} />
                                    <img className="carousel_arrow" alt="Flèche droite" src={icon_arrow_forward} onClick={handleNextProcess} />
                                </div>
                            </div>
                        ) : (
                            <div className='formule_process_comp-container'>
                                {process.map(([img, title, content], index) => (
                                    <Process
                                        key={index}
                                        img={img}
                                        index={index + 1}
                                        title={title}
                                        content={content}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </section>
                <section className='formule_galenique-container'>
                    <h3 className='formule_galenique-title'><label className="orange-color">A wide choice </label>of dosage<br />forms and packagings</h3>
                    <div className='formule_galenique-gridContainer'>
                        {content_galeniques.map(([img, title, content, subtitle], index) => (
                            <Conditionnement
                                key={index}
                                img={img}
                                title={title}
                                content={content}
                                subtitle={subtitle || null}
                            />
                        ))}
                    </div>
                </section>
                <section className='formule_demandeMp_global-container'>
                    <h3 className='formule_demandeMp-title'>your raw materials <br /> on demand</h3>
                    <article className='formule_demandeMp-text'>We package our raw materials according to<br /> your needs, whether plants, vitamins or<br /> minerals, in combination or separately.</article>
                    <p className='formule_demandeMp-btn' onClick={handleClick}>Contact us</p>
                    {/* Pop-up */}
                    <Popup isOpen={isPopupOpen} onClose={closePopup}>
                        <h2 className='popup-title'>En savoir plus sur un produit</h2>
                        <form className='popup-container-form'>
                            <div className='popup-container-2input'>
                                <div>
                                    <p className='popup-label'>Email</p>
                                    <input className="popup-input1" type="email" required />
                                </div>
                                <div>
                                    <p className='popup-label'>Numéro de téléphone</p>
                                    <input className="popup-input2" type="tel" required />
                                </div>
                            </div>
                            <div className='popup-container-2input'>
                                <div>
                                    <p className='popup-label'>Entreprise</p>
                                    <input className="popup-input1" type="text" required />
                                </div>
                                <div>
                                    <p className='popup-label'>Pays</p>
                                    <input className="popup-input2" type="text" required />
                                </div>
                            </div>
                            <p className='popup-label'>Message</p>
                            <p className='popup-subtitle'>Un expert vous répondra dans les plus brefs délais</p>
                            <textarea className='popup-textarea'></textarea>
                            <button className='popup-btn' type="submit">Envoyer</button>
                        </form>
                    </Popup>
                    <div className='formule_demandeMp-horizontalBar'></div>
                </section>
                <section className='formule_categoryCard-container'>
                    <h3 className='formule_categoryCard-title'>our ingredient categories</h3>
                    {isCarousel ? (
                        <div className="carousel">
                            <div key={forceReloadKey} className="carousel_item">
                                <CategoryCard
                                    title={categories[currentIndex].title}
                                    subtitle={categories[currentIndex].subtitle}
                                    type={categories[currentIndex].type}
                                    link={categories[currentIndex].link}
                                />
                            </div>
                            <div className='carousel_container_arrow'>
                                <img className="carousel_arrow" alt="Flèche droite" src={icon_arrow_back} onClick={handlePrev} />
                                <img className="carousel_arrow" alt="Flèche gauche" src={icon_arrow_forward} onClick={handleNext} />
                            </div>
                        </div>
                    ) : (
                        <nav className="homepage_nav_categorycard">
                            {categories.map((category, index) => (
                                <CategoryCard
                                    key={index}
                                    title={category.title}
                                    subtitle={category.subtitle}
                                    type={category.type}
                                    link={category.link}
                                />
                            ))}
                        </nav>
                    )}
                    <MoreInfo
                        label={"Nous contacter"}
                        link={"*"}
                    />
                </section>
            </div>
        </div>
    );
}